import {
    Button,
    Flex,
    HStack,
    Input,
    Table, Tbody,
    Td,
    Text, Th, Thead, Tr,
    VStack,
    useColorModeValue,
} from '@chakra-ui/react';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import UsuariosController from 'controllers/Usuarios/UsuariosController';
import { useEffect, useState } from 'react';

function CompaniaView() {
  const [data, setData] = useState([]);
  const [newUsuarioLogin, setNewUsuarioLogin] = useState("");
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Flex direction='column'  >
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader>
          <VStack spacing={4} align="stretch">
            <Text fontSize="xl" fontWeight="bold" color={textColor}>
              Empresas
            </Text>
            <HStack spacing={4}>
              <Input
                value={newUsuarioLogin}
                onChange={(e) => setNewUsuarioLogin(e.target.value)}
                placeholder="Nome da Empresa"
              />
              <Button onClick={addUsuario} colorScheme="blue" width="auto" minWidth="200px">
                Adicionar Empresa
              </Button>
            </HStack>
          </VStack>
        </CardHeader>
        <CardBody>
          <Table variant='simple' color={textColor}>
            <Thead>
              <Tr color='gray.400'>
                <Th color={textColor}>ID</Th>
                <Th color={textColor}>NOME</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((usuario) => (
                <UsuarioRow key={usuario.id} usuario={usuario} />
              ))}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
    </Flex>
  );
}

function UsuarioRow({ usuario }) {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Tr>
      <Td>{usuario.id}</Td>
      <Td>{usuario.name}</Td>
    </Tr>
  );
}

export default CompaniaView;